import { useEffect } from 'react'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

import PWAUpdateModal from '../modals/PWAUpdateModal'
import ErrorComponent from './error-component'
import ErrorPage from './error-page'

/**
 * Root router errorElement. Only a genuine 404 route response renders the not-found page; any
 * other uncaught route error (a render crash, a post-deploy stale-chunk load failure) renders an
 * honest failure surface instead of masquerading as a bad URL and misdirecting triage.
 *
 * No manual Sentry capture here: the console.error below already becomes a Sentry event through
 * the console capture integration, and the PWA update modal stays mounted because stale-chunk
 * errors are the most common way to reach this element — the modal is the recovery prompt.
 */
export default function RouteErrorPage() {
  const error = useRouteError()
  const isNotFound = isRouteErrorResponse(error) && error.status === 404

  useEffect(() => {
    if (!isNotFound) console.error('Uncaught route error', error)
  }, [error, isNotFound])

  if (isNotFound) return <ErrorPage />

  return (
    <>
      <ErrorComponent
        code="500"
        title="Something went wrong"
        message="An unexpected error occurred. Refresh the page to continue, or head back home."
        showRefreshButton
        showHomeLink
      />
      <PWAUpdateModal />
    </>
  )
}
